import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef} from '@angular/core';
import { Dimensions, ImageCroppedEvent, ImageTransform } from '../../../image-cropper/interfaces/index';
import { base64ToFile } from '../../../image-cropper/utils/blob.utils';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { ApiService } from '../../../services/api/api.service';
import { Constant } from '../../../common/constant/constant';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxImageCompressService } from 'ngx-image-compress';
import { BaseService } from 'src/app/modules/base/base.service';
import { Router } from '@angular/router';
import heic2any from 'heic2any'; // Import the library

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit, OnDestroy {
  @ViewChild('fileUpload') fileUpload!: ElementRef;
  @ViewChild('imageElement') imageElement!: ElementRef;

  @Input() userId;
  @Input() domainId;
  @Input() type;
  @Input() fromPage;
  @Input() profileType = "";
  @Input() id;
  @Input() bannerOption = "0";
  @Input() cropperStaticWidth = "0";
  @Input() cropperStaticHeight = "0";
  @Input() loginUserId = "0";
  @Input() contentTypeId = "0";
  @Input() format = "png";
  @Input() titleText: string = '';
  @Input() defaultSelected: string = '';
  @Output() updateImgResponce: EventEmitter<any> = new EventEmitter();
  @Output() closeClick: EventEmitter<any> = new EventEmitter();

  public bodyElem;
  public bodyClass:string = "auth";
  public bodyClass1:string = "profile-certificate";
  public bodyClass2:string = "image-cropper";
  public bodyClass3:string = "profile";
  public title: string = "";
  public footerElem;
  public bodyHeight: number;
  public innerHeight: number;
  public fileSize: number = 2000;
  public currentfileSize: number = 0;
  public uploadReady: boolean = false;
  uploadedFileType: string | null = null;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImageWidth: any = '';
  croppedImageHeight: any = '';
  croppedImageNew: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  transform: ImageTransform = {};

  public fileName: any = '';
  public invalidFileErr: string = '';
  public errorMsg = "Please upload file size below 2MB";
  public invalidFile: boolean = false;
  public loading: boolean = false;
  public selectImgError: boolean = false;
  public selectImgErrorMsg:string = '';
  public cropImgLoad: boolean = false;
  public progressStatus: string = 'Uploading...';
  public dekraNetworkId: string = '';
  
  // Resize Widow
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.bodyHeight = window.innerHeight;
    this.setScreenHeight();
  }


  constructor(
    private authenticationService: AuthenticationService,
    private apiUrl: ApiService,
    private httpClient: HttpClient,
    public activeModal: NgbActiveModal,
    private imageCompress: NgxImageCompressService,
    private baseSerivce: BaseService,
    private router: Router,
    ) { }

  ngOnInit(): void {

    this.dekraNetworkId = localStorage.getItem("dekraNetworkId") != undefined ? localStorage.getItem("dekraNetworkId") : '';
    this.bodyElem = document.getElementsByTagName('body')[0];
    this.bodyElem.classList.add(this.bodyClass);
    this.bodyElem.classList.add(this.bodyClass1);

    this.selectImgError = false;
    this.selectImgErrorMsg = '';

    this.id = this.id == undefined ? '' : this.id;

    if(this.profileType == '' || this.profileType == 'user-profile'){
      this.title = "profile picture";
    } else {
      switch(this.profileType) {
        case 'headquarter-image':
          this.title = "HQ Grapic";
          break;
        case 'categoryLogo':
          this.title = "Update Graphic";
          break;
        case 'partCategoryLogo':
          this.title = this.titleText;
          break;          
        case 'ka-banner':
          this.title = "Knowledge Article Banner";
          break;
        case 'banner-image':
          this.title = "Company Banner";
          break;
        case 'banner-image-second':
        case 'landing-header-banner':
        case 'document-banner':
        case 'adas-procedure-banner':   
        case 'add-banner': 
          this.title = "Banner Image";
          break;
        case 'video-thumb-file': 
          this.title = "Video Thumb Image";
        break;
        case 'login-bg':
          this.title = "Login Page BG";
          break;
       case 'add-shop':
          this.title = "Shop Logo/Image"
          break;
        case 'add-tools':
          this.title = "Tools Image"
          break;
        case 'add-gts-procedure':
          this.title = "GTS Banner"
          break;
        case 'add-template':
          this.title = "Template"
          break;
        case 'add-inspection':
          this.title = "Audit/Inspection" 
          break;
        default:
          this.title = "logo";
          break;  
      }
    }
    this.bodyHeight = window.innerHeight;
    this.setScreenHeight();

    setTimeout(() => {
      if(this.defaultSelected){
        console.log("Preloading Url...");
        this.loadImageFromImgTag()
      }
    }, 500)
  }

  // Set Screen Height
  setScreenHeight() {
    this.innerHeight = (this.bodyHeight - 130 );
  }

  loadImageFromImgTag() {
    const imgEle = this.imageElement.nativeElement;
    console.log("img: ", imgEle);

    if (imgEle.complete && imgEle.naturalWidth !== 0) {
      // Image is already loaded
      this.processImage(imgEle);
    } else {
      // Wait for load
      imgEle.onload = () => this.processImage(imgEle);
    }
  }

  processImage(img: HTMLImageElement) {
    console.log('processImage');
    
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;
  
    ctx?.drawImage(img, 0, 0);
  
    canvas.toBlob(blob => {
      if (!blob) return;
  
      const file = new File([blob], 'preload-image.png', { type: 'image/png' });
      this.simulateFileChangeEvent(file);
    }, 'image/png');
  }

  simulateFileChangeEvent(fileObj: File) {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(fileObj);
  
    const inputElement = this.fileUpload.nativeElement as HTMLInputElement;
    inputElement.files = dataTransfer.files;
  
    const event = new Event('change', { bubbles: true });
    inputElement.dispatchEvent(event);
  }

  /*fileChangeEvent(event: any): void {
    this.invalidFile = false;
    this.invalidFileErr = "";
    this.selectImgError = false;
    this.selectImgErrorMsg = '';
    this.imageChangedEvent = event;
    let selectFile = event.target.files[0];
    console.log(selectFile.name);
    let name = selectFile.name.split('.');
    let fname = name[0].replace(/'/g, '');
    fname = fname.replaceAll(/\s/g,'');
    fname = fname.replace('(', '');
    fname = fname.replace(')', '');
    // this.fileName = fname+".png";
    this.fileName = fname +'.'+this.format;
    console.log(this.fileName);
    this.currentfileSize = Math.round((selectFile.size / 1024));
  }*/

async fileChangeEvent(event: any): Promise<void> {

      this.loading = true;
      this.invalidFile = false;
      this.invalidFileErr = "";
      this.selectImgError = false;
      this.selectImgErrorMsg = ''; 

      const file = event.target.files[0];
      let name = file.name.split('.');
      let fname = name[0].replace(/'/g, '');
      fname = fname.replaceAll(/\s/g,'');
      fname = fname.replace('(', '');
      fname = fname.replace(')', '');
      // this.fileName = fname+".png";
      this.fileName = fname +'.'+this.format;
      console.log(this.fileName);
      this.currentfileSize = Math.round((file.size / 1024));

      if ((file?.type?.toLowerCase()?.includes('heic') || file?.type === '') && (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif'))) {
        try {
          // Convert HEIC to a Blob (e.g., as JPEG)
          console.log("HEIC Image");
          const convertedBlob: Blob = await heic2any({
            blob: file,
            toType: "image/png", // or "image/png"
            quality: 0.8, // Optional: specify quality for JPEG
          }) as Blob;

          // Convert the resulting Blob back to a File object for ngx-image-cropper
          // You need to create a new File object with a valid extension/type
          const convertedFile = new File([convertedBlob], this.fileName, {
            type: 'image/png',
            lastModified: Date.now(),
          });

          // Create a new FileList/Event to pass to the cropper
          const newEvent = { target: { files: [convertedFile] } };
          this.imageChangedEvent = newEvent;
          this.loading = false;
        } catch (error) {
          console.error("HEIC conversion failed:", error);
          // Handle the error (e.g., show a user message)
          this.loadImageFailed();
          this.loading = false;
        }
      } else {
        // For non-HEIC files, use the original event
        console.log("HEIC Image");
        this.imageChangedEvent = event;
        this.loading = false;
      }    
  }



  imageCropped(event: ImageCroppedEvent) {
      this.croppedImageWidth = event.width;
      this.croppedImageHeight = event.height;
      this.croppedImage = event.base64;
      this.croppedImageNew = event;
      console.log(event, base64ToFile(event.base64));
  }

  imageLoaded() {
    this.invalidFile = false;
    this.invalidFileErr = "";
    if(this.currentfileSize > this.fileSize){
      this.loading = false;
      this.invalidFile = true;
      this.invalidFileErr = this.errorMsg;
      this.cropImgLoad = false;
    }
    else{
      this.showCropper = true;
      this.cropImgLoad = true;
      this.selectImgError = false;
      this.selectImgErrorMsg = '';
    }
  }

  cropperReady(sourceImageDimensions: Dimensions) {
      console.log('Cropper ready', sourceImageDimensions);
  }

  loadImageFailed() {
      console.log('Load failed');
      this.showCropper = false;
      this.cropImgLoad = false;
      this.loading = false;
      this.invalidFile = true;
      this.selectImgError = true;
      this.selectImgErrorMsg = 'Not Supported';
  }

  rotateLeft() {
      this.canvasRotation--;
      this.flipAfterRotate();
  }

  rotateRight() {
      this.canvasRotation++;
      this.flipAfterRotate();
  }

  private flipAfterRotate() {
      const flippedH = this.transform.flipH;
      const flippedV = this.transform.flipV;
      this.transform = {
          ...this.transform,
          flipH: flippedV,
          flipV: flippedH
      };
  }


  flipHorizontal() {
      this.transform = {
          ...this.transform,
          flipH: !this.transform.flipH
      };
  }

  flipVertical() {
      this.transform = {
          ...this.transform,
          flipV: !this.transform.flipV
      };
  }

  resetImage() {
      this.scale = 1;
      this.rotation = 0;
      this.canvasRotation = 0;
      this.transform = {};
  }

  zoomOut() {
      this.scale -= .1;
      this.transform = {
          ...this.transform,
          scale: this.scale
      };
  }

  zoomIn() {
      this.scale += .1;
      this.transform = {
          ...this.transform,
          scale: this.scale
      };
  }

  toggleContainWithinAspectRatio() {
      this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  updateRotation() {
      this.transform = {
          ...this.transform,
          rotate: this.rotation
      };
  }


  uploadFile(){
    this.loading = true;
    const block = this.croppedImage.split(";");
    const contentType = block[0].split(":")[1];
    const realData = block[1].split(",")[1];
    const blob = this.b64toBlob(realData, contentType);
    const imageFile = new File([blob], this.fileName, {type: contentType});
    console.log(imageFile);
    if(this.fromPage == "chat-page")
    {
      this.updateImgResponce.emit(imageFile);
    }else{
      this.OnUploadFile(imageFile);
    }
  }

  uploadFileNew(){
    this.uploadReady = true;
    this.loading = true;
    if(this.currentfileSize < 600 ){
      console.log("not compressing..");
      setTimeout(() => {
        this.notCompressFile();
      }, 1);
    }
    else{
      setTimeout(() => {
        console.log("compressing..");
        //this.progressStatus = "Compressing..."
        this.compressFile(this.croppedImage,this.croppedImage);
      }, 1);
    }
  }

  // no need Compress Image
  notCompressFile(){
    const block = this.croppedImage.split(";");
    const contentType = block[0].split(":")[1];
    const realData = block[1].split(",")[1];
    const blob = this.b64toBlob(realData, contentType);
    const imageFile = new File([blob], this.fileName, {type: contentType});
    console.log(imageFile);
    if(this.fromPage == "chat-page")
    {
      this.updateImgResponce.emit(imageFile);
    }else{      
      this.OnUploadFile(imageFile);
    }
  }


  // Compress Image
  compressFile(file, image) {
    let orientation = -1;
    //let originalImageSize = this.imageCompress.byteCount(image);
    //console.warn('Size in bytes is now:', originalImageSize);
    this.imageCompress.compressFile(image, orientation, 50, 50).then(result => {
      console.log(result);
      //this.progressStatus = "Compressed.";
      let imgResultAfterCompress = result;
      let base64str = imgResultAfterCompress.substring(result.indexOf(',') + 1)
      let sizeOFCompressedImage:any = atob(base64str).length;
      this.currentfileSize = sizeOFCompressedImage;
      console.warn('Size in bytes after compression:', sizeOFCompressedImage);
      
      // call method that creates a blob from dataUri
      let compressImg = imgResultAfterCompress.split(',');
      console.log(compressImg);
      const imageBlob = this.dataURItoBlob(compressImg);
      console.log(imageBlob);
      const block = this.croppedImage.split(";");
      const fileType = block[0].split(":")[1];
      setTimeout(() => {
        const imageFile = new File([imageBlob], this.fileName, {type: fileType});
        if(this.fromPage == "chat-page")
        {
          this.updateImgResponce.emit(imageFile);
        }else{
          this.OnUploadFile(imageFile);
        }
      }, 500);
    });
  }



  dataURItoBlob(dataURI) {
    console.log(dataURI);
    const byteString = window.atob(dataURI[1]);
    const mimeString = dataURI[0].split(':')[1].split(';')[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], {type: mimeString});
    return blob;
  }


  b64toBlob(realData, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = atob(realData);
    var byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays);

    return blob;
  }

  OnUploadFile(imageFile) {
    let countryId = localStorage.getItem('countryId') == null || localStorage.getItem('countryId') == undefined ? '' : localStorage.getItem('countryId');
    console.log(imageFile);
    if(this.profileType == 'ka-banner' || this.profileType == 'cis-gallery') {
      this.uploadReady = false;
        this.loading = false;
        var imgData = {
          'show':this.croppedImage,
          'response': imageFile
        }
        this.updateImgResponce.emit(imgData);
    } else {
      const formData = new FormData();
      formData.append('file', imageFile);
      formData.append('user_id', this.userId );
      formData.append('domainId', this.domainId );
      formData.append('countryId', countryId );

      if(this.profileType == ''){
        formData.append('loginUserId', this.loginUserId);
      }
      else{        
        switch (this.profileType) {
          case 'businessProfile':
            formData.append('businessProfile', '1');
            break;
          case 'mfgLogo':
            formData.append('businessProfile', '2');
            formData.append('id', this.id);
            break;
          case 'makeLogo':
            formData.append('businessProfile', '3');
            formData.append('id', this.id);
            break;
          case 'categoryLogo':          
            formData.append('businessProfile', '4');
            formData.append('id', this.id);
            break;          
          case 'partCategoryLogo':
            formData.append('businessProfile', '32');
            formData.append('id', this.id);
            break;
          case 'reportLogo':
            formData.append('businessProfile', '5');
            formData.append('id', this.id);
            break;
          case 'document-banner':
          case 'folderLogo':
            formData.append('businessProfile', '6');
            if(this.id){
              formData.append('id', this.id);
            }            
            break;
          case 'banner-image':
          case 'banner-image-second':
            formData.append('businessProfile', '7');
            formData.append('id', this.id);
            break;
          case 'banner-image-manual':
            formData.append('businessProfile', '8');
            formData.append('id', '');
            break;
          case 'landing-header-banner':
            formData.append('businessProfile', '9');
            formData.append('id', this.id);
            break;
          case 'login-bg':
            formData.append('businessProfile', '10');
            formData.append('bannerOption', this.bannerOption);
            break;
          case 'adas-procedure-banner':
            formData.append('businessProfile', '11');
            formData.append('id', this.id);
            break;  
          case 'headquarter-image':
            formData.append('businessProfile', '12');
            formData.append('id', this.id);
            break;
        case 'add-shop':
          formData.append('businessProfile', '14');
          formData.append('id', this.id);
          break;       
        case 'add-gts-procedure':
          formData.append('businessProfile', '16');
          formData.append('id', this.id);
          break;
        case 'add-template':
          formData.append('businessProfile', '17');
          formData.append('id', this.id);
          break;
        case 'add-inspection':
          formData.append('businessProfile', '18');
          formData.append('id', this.id);
          break;
        case 'add-tools':
          formData.append('businessProfile', '15');
          formData.append('id', this.id);
          break;
        case 'level-image':
          formData.append('businessProfile', '13');
          formData.append('id', this.id);
          break;
          case 'add-banner':
            formData.append('businessProfile', '20');
            formData.append('bannerId', this.id);   
             //formData.append("networkId",this.dekraNetworkId);
          //formData.append("bannerId",this.id);               
            break;
          case 'video-thumb-file':
            formData.append('businessProfile', '31');
            formData.append('id', this.id);    
            formData.append('contentTypeId', this.contentTypeId); 
            //formData.append("networkId",this.dekraNetworkId);                             
            break;
          case 'video-library-category':
            formData.append('businessProfile', '33');
            if(this.id){
              formData.append('id', this.id);
            }                            
          case 'insurance-company':
            formData.append('businessProfile', '35');
            if(this.id){
              formData.append('id', this.id);
            }                            
            break;
        }
      }
      let serverUrl = this.profileType == 'video-library-category' || this.profileType == 'insurance-company' ? this.apiUrl.apiVideoCategoryImgfileUpload() : this.apiUrl.apifileUpload();
      this.httpClient.post<any>(serverUrl, formData)
      .subscribe(res => {
        console.log(res);
        this.invalidFile = false;
        this.invalidFileErr = "";
        if(res.status=='Success'){
          this.progressStatus = "";
          this.uploadReady = false;
          this.loading = false;
          let imgData = {
            'show':this.croppedImage,
            'response':res.data,
            'successmsg':res.result
          }
          if(this.profileType == 'video-thumb-file'){
            imgData['posterImageId'] = res.mediaId
          }
          this.updateImgResponce.emit(imgData);
        }
        else{
          this.uploadReady = false;
          this.showCropper = false;
          this.cropImgLoad = false;
          this.loading = false;
          this.invalidFile = true;
          this.invalidFileErr = res.data;
        }
        //console.log(res);
      },
      (error => {
        this.uploadReady = false;
        this.showCropper = false;
        this.cropImgLoad = false;
        this.loading = false;
        this.invalidFile = true;
        this.invalidFileErr = error;
      })
      );
    }
  }

  closePopup () {
    this.closeClick.emit(true);
  }

  ngOnDestroy() {
    this.bodyElem.classList.remove(this.bodyClass1);
    this.bodyElem.classList.remove(this.bodyClass2);

    let urlVal = this.router.url;
    let urlValSplit = urlVal.split("/");
    if(urlValSplit[1] == 'headquarters'){
      this.bodyElem.classList.remove(this.bodyClass);
      this.bodyElem.classList.remove(this.bodyClass3);
    }

  }



}
